export default __webpack_public_path__ + "static/media/ROME.9d9d90e6.jpg";